import { ProDetailList } from '@bedrock/eed-react';
import {
  FormCard,
  FormDescriptions,
  FormItemAssociatedEnterprise,
  FormItemAssociatedEnterpriseDetailList,
  FormItemEnterpriseName,
  FormItemOtherAttachmentDetailList,
  FormItemRelationship,
  FormModule,
} from '@purchase/supplier';
import React, { useMemo } from 'react';

const AssociatedEnterpriseInfo = (props: { formDetail: any }) => {
  const { formDetail } = props;

  const hasAssociatedEnterprise = useMemo(() => {
    return formDetail?.vendorAssociatedEnterpriseInfo?.associatedEnterprise;
  }, [formDetail]);

  return (
    <FormCard title="关联主体">
      <FormDescriptions columns={2} labelStyle={{ width: 160 }} margin={false}>
        <FormItemAssociatedEnterprise
          label="是否存在关联主体"
          name={['vendorAssociatedEnterpriseInfo', 'associatedEnterprise']}
          width={180}
        />
        {hasAssociatedEnterprise && (
          <FormItemAssociatedEnterpriseDetailList
            name={[
              'vendorAssociatedEnterpriseInfo',
              'associatedEnterpriseDetails',
            ]}
            span={2}
            label="关联信息"
          >
            <ProDetailList.Item
              label="#"
              name="#"
              meta={{ columnProps: { width: 50 } }}
            >
              {(value, record, index) => {
                return index + 1;
              }}
            </ProDetailList.Item>
            <FormItemEnterpriseName
              label="关联主体名称"
              name="enterpriseName"
              width={180}
              meta={{
                columnProps: { width: 200, className: 'font-bold' },
              }}
            />
            <FormItemRelationship label="关联关系" name="relationship" />
          </FormItemAssociatedEnterpriseDetailList>
        )}
      </FormDescriptions>
    </FormCard>
  );
};

export default AssociatedEnterpriseInfo;
